<template>
  <div>
    <h1>{{ $t("trial_balances") }}</h1>
    <DataTable
      :value="trialBalances"
      :loading="isLoading"
      responsive-layout="scroll"
      breakpoint="860px"
      class="
        p-datatable-striped p-datatable-gridlines p-datatable-sm
        pb-6
        d-grid
      "
    >
      <template #empty>
        <span>{{ $t("trial_balances_not_found") }}</span>
      </template>
      <Column
        field="year"
        :header="$t('year')"
        sortable
        header-class="trial-balance-year-column"
        body-class="trial-balance-year-column"
      />
      <Column
        field="month"
        :header="$t('month')"
        sortable
        header-class="trial-balance-month-column"
        body-class="trial-balance-month-column"
      >
        <template #body="slotProps">
          <span>
            {{ $t(`calendar.monthNames.${slotProps.data.month - 1}`) }}
          </span>
        </template>
      </Column>
      <Column
        field="message"
        :header="$t('message')"
        header-class="hide-message-column"
        body-class="hide-message-column"
      />
      <Column
        field="file"
        :header="$t('file')"
        header-class="trial-balance-file-column"
        body-class="trial-balance-file-column"
      >
        <template #body="slotProps">
          <PostFile
            :file="slotProps.data.file"
            :display-name="true"
            class="file-manager-displayed-file d-contents"
            @show-file="setDisplayFile(slotProps.data.file)"
          />
        </template>
      </Column>
    </DataTable>

    <DialogFiles
      :display-files="showFile"
      :files="fileToDisplay ? [fileToDisplay] : []"
      @closed="showFile = false"
    />
  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import DialogFiles from "../files/DialogFiles.vue";
import PostFile from "../posts/PostFile.vue";

export default {
  components: { DataTable, DialogFiles, PostFile },
  data() {
    return {
      trialBalances: [],
      isLoading: false,
      showFile: false,
      fileToDisplay: null,
    };
  },
  watch: {
    "$route.query.trialBalanceId": {
      immediate: true,
      handler(newId) {
        if (newId) {
          const id = Number(newId);
          if (this.trialBalances.length > 0) {
            this.openFileFromNotification(id);
          } else {
            this.getTrialBalances().then(() => {
              this.openFileFromNotification(id);
            });
          }
        }
      },
    },
  },
  created() {
    if (!this.$route.query.trialBalanceId) {
      this.getTrialBalances();
    }
  },
  methods: {
    getTrialBalances() {
      this.isLoading = true;
      return this.$root
        .apiGet(this.$root.api.trialBalances)
        .then((response) => {
          this.isLoading = false;
          this.trialBalances = response.data.data;
          return response.data.data;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$root.toastError(error.response.data.msg_code);
        });
    },
    setDisplayFile(file) {
      this.fileToDisplay = file;
      this.showFile = true;
    },
    openFileFromNotification(trialBalanceId) {
      const trialBalance = this.trialBalances.find(
        (tb) => tb.id === trialBalanceId
      );
      if (trialBalance && trialBalance.file) {
        this.setDisplayFile(trialBalance.file);
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 560px) {
  :deep(.hide-message-column) {
    display: none !important;
  }

  :deep(.p-datatable-tbody > tr) {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    gap: 0;
  }

  :deep(.p-datatable-tbody > tr > td.trial-balance-year-column) {
    grid-column: 1;
    grid-row: 1;
    border-right: 1px solid var(--surface-border);
  }

  :deep(.p-datatable-tbody > tr > td.trial-balance-month-column) {
    grid-column: 2;
    grid-row: 1;
  }

  :deep(.p-datatable-tbody > tr > td.trial-balance-file-column) {
    grid-column: 1 / -1;
    grid-row: 2;
    width: 100%;
    border-top: 1px solid var(--surface-border);
  }
  :deep(.p-datatable-tbody > tr > td.trial-balance-file-column .p-button) {
    width: 100%;
  }

  :deep(.p-datatable-thead > tr) {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }

  :deep(.p-datatable-thead > tr > th.trial-balance-year-column) {
    grid-column: 1;
    grid-row: 1;
    border-right: 1px solid var(--surface-border);
  }

  :deep(.p-datatable-thead > tr > th.trial-balance-month-column) {
    grid-column: 2;
    grid-row: 1;
  }

  :deep(.p-datatable-thead > tr > th.trial-balance-file-column) {
    grid-column: 1 / -1;
    grid-row: 2;
    width: 100%;
    border-top: 1px solid var(--surface-border);
  }

  :deep(.p-datatable-thead > tr > th.hide-message-column) {
    display: none !important;
  }
}
</style>
